import React from "react";

const ToggleSwitch = (props) => {
  const {
    children,
    checked,
    disabled,
    forwardedRef,
    id,
    onChange,
    dataAutomationId
  } = props;

  return (
    <div className="toggle-switch-btn">
      <input
        className="toggle-switch-btn__input"
        checked={checked}
        disabled={disabled}
        id={id}
        onChange={onChange}
        ref={forwardedRef}
        type="checkbox"
        data-automation-id={dataAutomationId}
      />
      { /* eslint-disable-next-line */}
      <label className="toggle-switch-btn__label" htmlFor={id}>
        <span className="toggle-switch-btn__knob" />
      </label>
      {children && (
        <span className="toggle-switch-btn__name">
          {children}
        </span>
      )}
    </div>
  );
};

export default ToggleSwitch;